"use client";
import React from "react";
import ActiveDatesSection from "@/components/coupon/activeDatesSection";
import BreadCrumbs from "@/components/coupon/breadCrumbs";
import SaveBuyXGetY from "@/components/coupon/buy-x-get-y/saveCoupon";
import SelectProducts from "@/components/coupon/buy-x-get-y/selectProducts";
import DiscountMethodSection from "@/components/coupon/discountMethodSection";

const BuyXGetYPage = () => {
  return (
    <div className="flex gap-5 flex-wrap">
      <BreadCrumbs page="Buy X Get Y" />
      <DiscountMethodSection currentPage="buyXGetY" />
      <SelectProducts />
      <div className="grid w-full grid-cols-[repeat(auto-fit,minmax(min(250px,100%),1fr))] gap-5">
        <ActiveDatesSection currentPage="buyXGetY" />
      </div>
      <SaveBuyXGetY currentPage="buyXGetY" />
    </div>
  );
};

export default BuyXGetYPage;
